import React, { useEffect, useState, useContext } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import AddressInput from "./AddressInput";
import SelectInputWithIcon from "common/SelectInputWithIcon";
import SelectMultiAutocomplete from "common/SelectMultiAutocomplete";
import NumberInput from "common/NumberInputWithSpinnerState";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import Radio from "common/Radio.jsx";
import Actions from "../Actions";
import { periodChoices } from "common/constants";

const ReloadButton = styled.div`
  padding-right: 10px;
  cursor: pointer;
`;

const IconRefresh = styled.i`
  color: #999;
  &:hover {
    color: #000;
  }
  transition: all 0.5s;
`;

const ActionsWrapper = styled.div`
  margin: -10px 10px 20px 10px;
`;

const TimeRefreshWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 0 10px;
`;

const ControlsAndResultsLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: -10px 10px 10px 10px;
`;

const SelectsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;

  .addressSelect {
    width: 310px;
  }
  .typesSelect {
    width: 350px;
  }
  .meanThresholdSelect {
    width: 300px;
  }
`;

const SelectWrapper = styled.div`
  width: 150px;
  margin: 0 10px;
`;

const MetricsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 20px 20px 0px 20px;
`;

const _directionOptions = [
  { label: "Downlink", value: "downlink" },
  { label: "Uplink", value: "uplink" },
];
  
const _metricOptions = [
  { label: "Average Group Speed", value: "averageSpeed" },
  { label: "Active Flows", value: "activeFlows" },
  { label: "Active Subscribers", value: "activeSubscribers" },
  { label: "Flows Created Per Minute", value: "flowsCreated" },
  { label: "Latency-P80", value: "latency-80p" },
  { label: "Latency-Median", value: "latency-med" },
  { label: "Latency-Mean-Min", value: "latency" },
  { label: "Retransmissions", value: "retransmissions" },
  { label: "Congestion", value: "congestion" },
];

const _useOptions = [
  { label: "Use filtered IP for metrics", value: "ipAddress" },
  { label: "Use subs-id for filtered IP", value: "subsId" },
];

const RadioOptionWrapper = styled.div`
  display: flex;
`;

const MetricsLabel = styled.div`
  width: 35px;
  display: flex;
  align-items: center;

  .material-icons {
    font-size: 20px;
  }
`;

const MetricOptionsWrapper = styled.div`
  width: 100%;

  div[name="metric"] {
    display: flex;
    align-items: center;

    label {
      display: flex;
      align-items: center;
      line-height: 16px !important;
    }
  }
`;
const FilteringControls = ({
  settings,
  onChange,
  groupTypes,
  thresholds,
  setThresholds,
}) => {
  const actions = useContext(ActionsContext);
  const handleChange = (event) => {
    const { target } = event;

    const value =
      target.type !== "checkbox"
        ? target.value
        : target.value === "on" && target.checked === true;
    onChange({ ...settings, [target.name]: value });
  };

  const optionsTypesSet = new Set(Object.values(groupTypes));

  return (
    <>
      <ActionsWrapper>
        <Actions />
      </ActionsWrapper>
      <ControlsAndResultsLayout>
        <SelectsWrapper>
          <SelectWrapper>
            <SelectInputWithIcon
              title="Direction"
              name="direction"
              icon="import_export"
              selected={settings.direction}
              onChange={handleChange}
              options={_directionOptions}
            />
          </SelectWrapper>
          <SelectsWrapper className="addressSelect">
            <AddressInput
              value={settings.ipAddress}
              name="ipAddress"
              onChange={handleChange}
              allowIpRanges={false}
            />
          </SelectsWrapper>
          {settings.ipAddress ? (
            <SelectWrapper>
              <SelectInputWithIcon
                title="use"
                name="use"
                icon="label_outline"
                selected={settings.use}
                onChange={handleChange}
                options={_useOptions}
              />
            </SelectWrapper>
          ) : null}
          <SelectWrapper className="typesSelect">
            <SelectMultiAutocomplete
              icon="group"
              title="Group Type"
              name="group-type-selector"
              placeholder="Group Type"
              className="group-type-selector"
              options={[...optionsTypesSet].map((type) => {
                return { label: type, value: type };
              })}
              key={JSON.stringify([...optionsTypesSet])}
              onChange={(value) =>
                onChange({
                  ...settings,
                  types: value.map((optionType) => optionType.value),
                })
              }
            />
          </SelectWrapper>
        </SelectsWrapper>
      </ControlsAndResultsLayout>
      <TimeRefreshWrapper>
        <SelectWrapper>
          <SelectInputWithIcon
            title="Time Period"
            name="timePeriod"
            icon="date_range"
            selected={settings.timePeriod}
            onChange={handleChange}
            options={periodChoices}
          />
        </SelectWrapper>
        <ReloadButton>
          <a
            onClick={() => actions.send("do-load")}
            data-toggle="cardloading"
            data-loading-effect="pulse"
            title="Refresh"
          >
            <IconRefresh className="material-icons">refresh</IconRefresh>
          </a>
        </ReloadButton>
      </TimeRefreshWrapper>
      <MetricsWrapper>
        <MetricsLabel>
          <i className="material-icons">insert_chart</i>
        </MetricsLabel>
        <MetricOptionsWrapper>
          <ColumnsGrid columns={6} minWidth="18rem" rowGap="0">
            <Radio
              options={_metricOptions}
              name="metric"
              defaultValue={settings.metric}
              itemWrapper={RadioOptionWrapper}
              onChange={(event) =>
                onChange({
                  ...settings,
                  metric: event.target.value,
                })
              }
            />
          </ColumnsGrid>
        </MetricOptionsWrapper>
      </MetricsWrapper>
    </>
  );
};

export default FilteringControls;